module.exports = __webpack_public_path__ + "static/media/Brif-1.c2034f07.mp4";